import { createContext } from 'react';

import { Store, createStore } from '../../../core/store/store.js';
import { PieChartState, initialState } from '../types/state.js';

export const PieChartStateContext = createContext<Store<PieChartState>>(
  createStore<PieChartState>(initialState),
);

PieChartStateContext['displayName'] = 'PieChartStateContext';
